module.exports = __webpack_public_path__ + "img/i_phone_red.5b00489c.svg";